import Corks from '@/app/[locale]/wallet/components/commons/Corks';
import { useTranslations } from 'next-intl';
import { Button } from 'src/components/design-system';
import { Link } from '@/i18n/routing';

import type { JSX } from "react";

interface Props {
  points: number;
  prizeId: number;
}

const RedeemButton = (props: Props): JSX.Element => {
  const t = useTranslations('loyalty');

  return (
    <Link
      href={{ pathname: '/wallet/checkout', query: { prize: props.prizeId } }}
    >
      <Button type="link" size="lg" className="text-xl w-full">
        {t.rich('prizeDetail.redeemFor', {
          cork: (c) => (
            <Corks
              loyaltyPoints={props.points}
              corkColor="white"
              corkSize="1.5"
              numberColor="white"
              numberSize="xl"
              numberWeight="bold"
            />
          ),
        })}
      </Button>
    </Link>
  );
};

export default RedeemButton;
